import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import { reduce, isArray, concat } from 'lodash';
import moment from 'moment';
import { Popover, Overlay, Button } from 'react-bootstrap';
import DateTimeDisplay from '../../../../components/date-time-display';

class DateRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    this.clear = this.clear.bind(this);
    this.close = this.close.bind(this);
  }

  handleChange(date) {
    const { data, colDef: { field } } = this.props;
    this.props.onChange(data, field, date);
    this.setState({ show: false });
  }

  handleToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ show: !this.state.show });
  }

  close() {
    this.setState({ show: false });
  }

  clear() {
    this.handleChange(null);
  }

  stopPropagation(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  renderPopover() {
    const { 
      value, data, colDef: { field }, cacheDates,
    } = this.props;
    const { show } = this.state;
    const errors = null;
    let minDate = null;
    let maxDate = null;
    const dates = cacheDates[data._id];
    if (dates) {
      if (field === 'start') {
        maxDate = dates.end ? dates.end.clone().subtract(1, 'days') : null;
      } else if (field === 'end') {
        minDate = dates.start ? dates.start.clone().add(1, 'days') : null;
      }
    }


    const popover = (
      <Popover id={`owner-${this.props.data._id}`}>
        {show &&
          <div>
            <DatePicker
              inline
              minDate={minDate}
              maxDate={maxDate}
              selected={value}
              onChange={this.handleChange}
              showYearDropdown
              scrollableYearDropdown
            />
          </div>
        }
        {errors !== null && errors.length > 0 &&
          <div className="alert alert-danger" style={{ margin: 0 }}>
            {errors.map(m => <div key={m}>{m}</div>)}
          </div>
        }
      </Popover>
    );
    return (
      <Overlay
        show={show}
        onHide={this.close}
        placement="bottom"
        rootClose
        target={() => this.target}
      >
        {popover}
      </Overlay>
    );
  }

  render() {
    const {
      data, value, deletingMembers, updatingMembers,
    } = this.props;
    const hasDate = value !== undefined && value !== null;
    const deleting = deletingMembers[data._id] === true;
    const updating = updatingMembers[data._id] === true;
    const disabled = deleting || updating;
    const handler = disabled ? this.stopPropagation : this.handleToggle;
    return (
      <div>
        <a
          href=""
          ref={(el) => { this.target = el; }}
          onClick={handler}
        >
          {hasDate && <DateTimeDisplay value={value} format="short" />}
          {!hasDate && <em className="text-muted">N/A</em>}
        </a>
        {hasDate && !updating &&
          <Button
            onClick={this.clear}
            bsStyle="link"
            bsSize="sm"
            disabled={disabled}
          >
            <Fa className="text-muted" name="times-circle" />
          </Button>
        }
        {updating && <span className="text-muted">&nbsp;<Fa name="spinner" spin /></span>}
        {this.renderPopover()}
      </div>
    );
  }
}

DateRenderer.propTypes = {
  value: PropTypes.instanceOf(moment),
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  colDef: PropTypes.shape({
    field: PropTypes.string.isRequired,
  }).isRequired,
  cacheDates: PropTypes.shape({}),
  deletingMembers: PropTypes.shape({}),
  updatingMembers: PropTypes.shape({}),
  onChange: PropTypes.func,
};
DateRenderer.defaultProps = {
  value: null,
  cacheDates: {},
  deletingMembers: {},
  updatingMembers: {},
  onChange: () => {},
};

export default connect(() => ({}), null, null, { forwardRef: true })(DateRenderer);
